import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 13L7.83 13L13.42 18.59L12 20L4 12L12 4L13.41 5.41L7.83 11L20 11L20 13Z",
		fill: "currentColor"
	})
});
export default SvgLeftArrow;
